import { useState, useEffect } from 'react';
import { loadModules } from '@esri/react-arcgis';

const Basemap = (props) => {
    const [basemap, setBasemap] = useState(null);
    useEffect(() => {
        loadModules(['esri/Basemap', 'esri/layers/TileLayer']).then(([Basemap, TileLayer]) => {
            var satelliteLayer = new TileLayer({
                url: "http://gisweb.charlottesville.org/arcgis/rest/services/aerials_2018_world_mercator_expanded/MapServer"
            });
            var baseLayer = new TileLayer({
                url: "http://gisweb.charlottesville.org/arcgis/rest/services/basemap_world_mercator_expanded/MapServer"
            });
            var basemap = new Basemap({
                baseLayers: [baseLayer],
                title: "COC - Satellite",
                id: "satellite"
            });
            setBasemap(basemap);
            props.map.basemap = basemap;
        }).catch((err) => console.error(err));
        return function cleanup() {
            props.map.basemap = "streets";
        }
    }, []);
    return null;
}
export default Basemap;


// WEBPACK FOOTER //
// ./src/components/Basemap.js